export var State;
(function (State) {
    State["idle"] = "idle";
    State["new"] = "new";
    State["edited"] = "edited";
    State["hidden"] = "hidden";
    State["deleted"] = "deleted";
})(State || (State = {}));
